var map = {
	"./AISummit/1000183655_enhanced.png": 38504,
	"./AISummit/1000200537_1.png": 7923,
	"./AISummit/1000203136.png": 82279,
	"./AISummit/AI & Copilot summit Indore Posters  (LinkedIn Article Cover Image).png": 60442,
	"./AISummit/Medicaps.png": 19629,
	"./AISummit/gdg svvv white.png": 48965,
	"./AISummit/neevcloud_logo_light.png": 47897,
	"./AISummit/sponsor.png": 9116,
	"./Aicopilot.png": 13537,
	"./Bootcamp.png": 7372,
	"./Containerpeople.png": 99879,
	"./Datacode_PNG_Logo.png": 16060,
	"./Datacode_Sagethon_Logo.png": 93178,
	"./Devfolio_Logo-White.png": 25981,
	"./EventResources/docx.png": 64339,
	"./EventResources/drive.png": 21525,
	"./EventResources/figma.png": 68025,
	"./EventResources/github.png": 24028,
	"./EventResources/tutorial.png": 61147,
	"./Green Disease Prevention Instagram Post.png": 17418,
	"./Hackthone.png": 26910,
	"./Internhip.png": 10156,
	"./Polygon_Logo-White.png": 37079,
	"./academicearth.jpeg": 45401,
	"./ageoflearning.jpeg": 18436,
	"./alison.jpeg": 94252,
	"./android_tech.jpeg": 90828,
	"./android_tutorial.jpeg": 84626,
	"./angular_tech.jpeg": 30171,
	"./angular_tutorial.jpeg": 38625,
	"./bg/Rectangle 14formbg.jpg": 52534,
	"./bg/Wittyhacks-bg.png": 51712,
	"./bg/days-hero.jpeg": 15246,
	"./bitdegree.jpeg": 91975,
	"./bootstrap_tech.jpeg": 40083,
	"./c_quiz_test_header.png": 58423,
	"./c_tech.jpeg": 86886,
	"./c_tutorial.jpeg": 59816,
	"./classcentral.jpeg": 16317,
	"./cn_tech.jpeg": 44394,
	"./codecademy.jpeg": 78660,
	"./codechef.jpeg": 67209,
	"./codecombat.jpeg": 20053,
	"./codeeval.jpeg": 79911,
	"./codeforces.jpeg": 47857,
	"./coder1.jpeg": 43896,
	"./coderbyte.jpeg": 34215,
	"./codesignal.jpeg": 65997,
	"./codewars.jpeg": 9290,
	"./codinggame.jpeg": 42080,
	"./codingninjas.jpeg": 38712,
	"./community.png": 31060,
	"./community/LearnCommunity.png": 26444,
	"./community/checkbox-circle-fill.png": 50531,
	"./community/community partners/logo1.png": 45266,
	"./community/community partners/logo2.png": 76233,
	"./community/community partners/logo3.png": 98112,
	"./community/community partners/logo4.png": 33087,
	"./community/community partners/logo5.png": 36150,
	"./community/contribute-section.png": 19062,
	"./community/contributors/profile1.png": 81552,
	"./community/event-section.png": 4519,
	"./community/footer.png": 91059,
	"./community/hero-section-bg.png": 35,
	"./community/join-community-1.png": 11931,
	"./community/join-community-2.png": 49952,
	"./community/join-community-3.png": 28073,
	"./community/join-community-icon.png": 82559,
	"./community/plane-departure.png": 98188,
	"./community/quote-section-bg.png": 88111,
	"./community/quotes.png": 42314,
	"./community/redirect-icon.png": 28891,
	"./community/stars.png": 20062,
	"./community/story-section-bg.png": 17026,
	"./community/story-section/profile1.png": 90297,
	"./community/team/profile1.png": 19135,
	"./community/timer.png": 80406,
	"./community/volunteer-section.png": 21297,
	"./companies/facebook.png": 36263,
	"./cover4.jpeg": 69993,
	"./cpp_tech.jpeg": 97886,
	"./css_tech.jpeg": 33868,
	"./datacodeheader1.jpeg": 6707,
	"./datacodeheader2.jpeg": 8646,
	"./datacodeheader3.jpeg": 47309,
	"./datacodelive.png": 73686,
	"./datacodelogo.jpeg": 4850,
	"./datasciencedojo.jpeg": 2172,
	"./datastructure.jpeg": 93705,
	"./dayscode/about/certificate.png": 31159,
	"./dayscode/about/duration.png": 72768,
	"./dayscode/about/exclusive.png": 56646,
	"./dayscode/about/lifetime.png": 15997,
	"./dayscode/about/mic.png": 84167,
	"./dayscode/about/problems.png": 73392,
	"./dayscode/about/rupee.png": 10109,
	"./dayscode/arrow.png": 87399,
	"./dayscode/base/checklist.png": 80652,
	"./dayscode/base/help.png": 82991,
	"./dayscode/ellipse.png": 59218,
	"./dayscode/explore/box1.png": 41858,
	"./dayscode/explore/box2.png": 90041,
	"./dayscode/explore/box3.png": 93136,
	"./dayscode/groups/fresher.png": 69154,
	"./dayscode/groups/student.png": 71530,
	"./dayscode/groups/working.png": 46474,
	"./dayscode/heart.png": 6876,
	"./dayscode/hot.png": 86161,
	"./dayscode/image 2.png": 16005,
	"./dayscode/image 3.png": 86588,
	"./dayscode/image.png": 65895,
	"./dayscode/image1.png": 17182,
	"./dayscode/line.png": 56756,
	"./dayscode/oval.png": 11534,
	"./dayscode/upload.png": 37085,
	"./dayscode/voice/author.png": 68350,
	"./dayscode/voice/zoomer.png": 1903,
	"./dbms_tech.jpeg": 69615,
	"./devcindore.jpeg": 83067,
	"./django_tech.jpeg": 54048,
	"./ds_tech.jpeg": 59138,
	"./ds_tutorial.jpeg": 16876,
	"./dzone.jpeg": 14570,
	"./educause.jpeg": 61455,
	"./ethindia-light.png": 15094,
	"./event_gallary/a.jpeg": 1125,
	"./event_gallary/b.jpeg": 44132,
	"./event_gallary/beginners_coding_banner.jpeg": 50391,
	"./event_gallary/c.jpeg": 76875,
	"./event_gallary/d.jpeg": 32426,
	"./event_gallary/datacodeheader1.jpeg": 91305,
	"./event_gallary/datacodeheader2.jpeg": 42568,
	"./event_gallary/e.jpeg": 35377,
	"./event_gallary/f.jpeg": 87088,
	"./event_gallary/g.jpeg": 60487,
	"./event_gallary/h.jpeg": 71494,
	"./event_gallary/i.jpeg": 19181,
	"./event_gallary/j.jpeg": 16300,
	"./event_gallary/k.jpeg": 92979,
	"./event_gallary/l.jpeg": 66898,
	"./event_gallary/m.jpeg": 39910,
	"./event_gallary/n.jpeg": 70136,
	"./event_gallary/o.jpeg": 81679,
	"./exercism.jpeg": 97850,
	"./free-class/profile1.png": 29427,
	"./freecodecamp.jpeg": 58582,
	"./freecodecamp1.jpeg": 69942,
	"./geeksforgeeks.jpeg": 49625,
	"./gif/coding-problem.gif": 4461,
	"./gif/congratulations.gif": 93438,
	"./gif/it-developer.gif": 28319,
	"./gif/landing-days-code.gif": 55012,
	"./gif/waiting-timer.gif": 56070,
	"./git_tech.jpeg": 56325,
	"./h2.jpeg": 89886,
	"./hackerrank.jpeg": 65224,
	"./harvardextentionschool.jpeg": 76870,
	"./header2.jpeg": 30081,
	"./headerdark.jpeg": 78561,
	"./html_tech.jpeg": 83594,
	"./html_tutorial.jpeg": 74164,
	"./icon192.png": 97922,
	"./internship/bootstrap.png": 61598,
	"./internship/career.webp": 31526,
	"./internship/css.png": 51585,
	"./internship/datacode.png": 72085,
	"./internship/express.png": 17876,
	"./internship/firstStep.jpg": 14072,
	"./internship/groupp.jpg": 62425,
	"./internship/html.png": 68065,
	"./internship/js.png": 4859,
	"./internship/life1.JPG": 43996,
	"./internship/life2.JPG": 56427,
	"./internship/life3.JPG": 72238,
	"./internship/life4.JPG": 14005,
	"./internship/mongoDB.jpg": 42106,
	"./internship/next.png": 27661,
	"./internship/node.png": 78090,
	"./internship/p2.png": 6464,
	"./internship/p3.png": 77641,
	"./internship/p4.png": 3382,
	"./internship/p5.png": 65119,
	"./internship/p6.png": 51556,
	"./internship/pj.png": 10168,
	"./internship/react.png": 60961,
	"./internship/sass.png": 73320,
	"./internship/tailwind.png": 79186,
	"./internship/techvraksh.jpg": 97891,
	"./internship/ts.png": 37157,
	"./iversity.jpeg": 13387,
	"./java_tech.jpeg": 3221,
	"./js.jpeg": 76607,
	"./js_tech.jpeg": 30100,
	"./khanacademy.jpeg": 32746,
	"./mitocw.jpeg": 78589,
	"./mock_drive_flow.png": 27105,
	"./mocktestdrive.png": 55861,
	"./nav_brand_logo.jpeg": 16283,
	"./oops_tech.jpeg": 8168,
	"./openclassrooms.jpeg": 14020,
	"./opencourser.jpeg": 22497,
	"./openlearning.jpeg": 88154,
	"./os_tech.jpeg": 56047,
	"./platzi.jpeg": 3940,
	"./progate.jpeg": 93128,
	"./programming_blog.jpeg": 37494,
	"./python_programming_question.jpeg": 98053,
	"./python_tech.jpeg": 99919,
	"./pythonmcq.jpeg": 43477,
	"./pythontech.jpeg": 52654,
	"./rdbms_tech.jpeg": 14517,
	"./react_tech.jpeg": 4772,
	"./saylor.jpeg": 29696,
	"./sdlc_tech.jpeg": 8299,
	"./simplilearn.jpeg": 5812,
	"./sitepoint.jpeg": 29235,
	"./sololearn1.jpeg": 59102,
	"./speakers/aaveg.png": 57264,
	"./speakers/abhinav.png": 31843,
	"./speakers/aditya.png": 13212,
	"./speakers/ankit.jpeg": 61736,
	"./speakers/anshika.png": 52805,
	"./speakers/ayushi.jpeg": 6446,
	"./speakers/datacode.png": 13773,
	"./speakers/dhanushka.svg": 22951,
	"./speakers/gopal.png": 89417,
	"./speakers/ishaan.png": 35258,
	"./speakers/jayesh.png": 92618,
	"./speakers/ketki.png": 95436,
	"./speakers/manas.png": 10356,
	"./speakers/mrinal.png": 63893,
	"./speakers/rajan.png": 24354,
	"./speakers/rajeev.png": 43375,
	"./speakers/sai.png": 61209,
	"./speakers/shubhangi.png": 3745,
	"./speakers/sonakshi.png": 84776,
	"./sql_tech.jpeg": 25617,
	"./sql_tutorial.jpeg": 39715,
	"./svg/404.svg": 14814,
	"./svg/5 SCENE.svg": 74227,
	"./svg/8 SCENE.svg": 63642,
	"./svg/Add.svg": 52127,
	"./svg/Analytics.png": 94128,
	"./svg/Analytics.svg": 94266,
	"./svg/Android.png": 32653,
	"./svg/Android.svg": 27407,
	"./svg/Angular.png": 93870,
	"./svg/Angular.svg": 7940,
	"./svg/Blogs.png": 11539,
	"./svg/Blogs.svg": 39301,
	"./svg/Bootstrap.svg": 7396,
	"./svg/C.svg": 12925,
	"./svg/CSS.svg": 99103,
	"./svg/C_sharp.svg": 42180,
	"./svg/Comment.svg": 93945,
	"./svg/Computer_Science.svg": 16498,
	"./svg/Cpp.svg": 50453,
	"./svg/DART.svg": 65729,
	"./svg/DataScience.png": 51470,
	"./svg/DataScience.svg": 6412,
	"./svg/Datastructures.png": 44112,
	"./svg/Datastructures.svg": 4212,
	"./svg/Docker.svg": 88206,
	"./svg/Earn_grey.svg": 22794,
	"./svg/Express js.svg": 70887,
	"./svg/Find.svg": 43723,
	"./svg/FindDark.png": 61087,
	"./svg/Find_flow-card.svg": 68433,
	"./svg/Firebase.svg": 55701,
	"./svg/Flutter.svg": 8288,
	"./svg/Git.svg": 97306,
	"./svg/Go_lang.svg": 83923,
	"./svg/HTML.svg": 47561,
	"./svg/Help.svg": 70387,
	"./svg/IOS.svg": 96477,
	"./svg/Interview.png": 78193,
	"./svg/Interview.svg": 69999,
	"./svg/JS.png": 16123,
	"./svg/Java.png": 2634,
	"./svg/Java.svg": 24714,
	"./svg/Javascript.svg": 42487,
	"./svg/Join.svg": 83614,
	"./svg/Jquery.svg": 1072,
	"./svg/Kali Linux.svg": 59241,
	"./svg/Kotlin.svg": 88581,
	"./svg/Larvel.svg": 77296,
	"./svg/Learn.svg": 55448,
	"./svg/LearnDark.png": 60470,
	"./svg/Love.svg": 81994,
	"./svg/MATLAB.svg": 3057,
	"./svg/Mcq.png": 82489,
	"./svg/Mcq.svg": 55247,
	"./svg/Mongo DB.svg": 81332,
	"./svg/No_data_re_kwbl.svg": 95973,
	"./svg/PHP.svg": 93110,
	"./svg/PostgreSQLImage.svg": 58059,
	"./svg/Practice.svg": 10369,
	"./svg/PracticeDark.png": 96169,
	"./svg/Python.png": 620,
	"./svg/Python.svg": 93056,
	"./svg/Quiz.png": 64401,
	"./svg/Quiz.svg": 40753,
	"./svg/R.svg": 7596,
	"./svg/React.png": 91777,
	"./svg/React.svg": 39523,
	"./svg/React_native.svg": 3399,
	"./svg/Redux.svg": 88704,
	"./svg/Ruby.svg": 19010,
	"./svg/SQL.svg": 87022,
	"./svg/Sass.svg": 98696,
	"./svg/SaveLogo.svg": 6772,
	"./svg/Software_Testing.svg": 59900,
	"./svg/Swift.svg": 11723,
	"./svg/Test.svg": 77242,
	"./svg/TestDark.png": 89110,
	"./svg/Tutorial.svg": 89104,
	"./svg/TutorialDark.png": 21540,
	"./svg/Typescript.svg": 42367,
	"./svg/Vue.svg": 69658,
	"./svg/aboutus.svg": 67381,
	"./svg/all-the-best.svg": 14616,
	"./svg/bell.png": 18485,
	"./svg/blog.webp": 87958,
	"./svg/certificate.svg": 15643,
	"./svg/code-hand.png": 25243,
	"./svg/code-logic.svg": 26304,
	"./svg/code-mentorship.svg": 34399,
	"./svg/code-practice.svg": 64125,
	"./svg/code_1.svg": 30405,
	"./svg/colabrate.png": 74081,
	"./svg/community.svg": 94513,
	"./svg/community_partner.svg": 90378,
	"./svg/confirmation.svg": 99125,
	"./svg/contribute_timeline.svg": 4959,
	"./svg/contributor.svg": 77725,
	"./svg/days-code-header.gif": 2560,
	"./svg/dayscode-header.svg": 90118,
	"./svg/dayscode.gif": 10319,
	"./svg/discussion.svg": 53818,
	"./svg/django.svg": 54595,
	"./svg/education_partner.svg": 63503,
	"./svg/event-banner.png": 18973,
	"./svg/ex_question.png": 36046,
	"./svg/ex_question.svg": 5704,
	"./svg/ex_question.webp": 25380,
	"./svg/find.png": 94619,
	"./svg/find.webp": 33905,
	"./svg/find_timeline.svg": 18459,
	"./svg/forgot-password.svg": 92923,
	"./svg/goodies.svg": 41646,
	"./svg/google.svg": 88023,
	"./svg/html-css.svg": 29459,
	"./svg/instagram.svg": 65138,
	"./svg/interview.webp": 91053,
	"./svg/landing-illustrate.png": 26393,
	"./svg/laptop-green.png": 69280,
	"./svg/learn.png": 36950,
	"./svg/learn.webp": 28628,
	"./svg/learn_timeline.svg": 64434,
	"./svg/learning-objective.png": 5854,
	"./svg/linux.png": 83946,
	"./svg/linux.svg": 15004,
	"./svg/logo.svg": 22563,
	"./svg/logo_white.svg": 97949,
	"./svg/mcq.webp": 35373,
	"./svg/mission.png": 37194,
	"./svg/monolog.svg": 72415,
	"./svg/node.svg": 35262,
	"./svg/oracle.svg": 30812,
	"./svg/postgreSQL.svg": 87588,
	"./svg/practice.png": 40133,
	"./svg/practice.webp": 7647,
	"./svg/profile.jpg": 12695,
	"./svg/question.svg": 34850,
	"./svg/quiz.webp": 69103,
	"./svg/reach.svg": 50839,
	"./svg/reset-password.svg": 91079,
	"./svg/save.svg": 64017,
	"./svg/self-analysis.svg": 73651,
	"./svg/seo.svg": 99729,
	"./svg/signup.svg": 2738,
	"./svg/social_media.svg": 25826,
	"./svg/speaker.png": 34603,
	"./svg/take-break.svg": 32349,
	"./svg/tech_mentor.svg": 97766,
	"./svg/test.png": 76918,
	"./svg/test.webp": 92374,
	"./svg/test_timeline.svg": 78088,
	"./svg/trophy.png": 76076,
	"./svg/tutorial-icon.png": 66544,
	"./svg/tutorial.png": 70028,
	"./svg/tutorial.webp": 37340,
	"./svg/undraw_Co_workers_re_1i6i.png": 61970,
	"./svg/undraw_File_searching_re_3evy.png": 55649,
	"./svg/undraw_Operating_system_re_iqsc.png": 79926,
	"./svg/undraw_Work_time_re_hdyv.png": 88991,
	"./svg/undraw_done_a34v.png": 33985,
	"./svg/undraw_feeling_proud_qne1.png": 59979,
	"./svg/undraw_online_test_gba7.png": 7726,
	"./svg/undraw_predictive_analytics_kf9n.png": 56659,
	"./svg/undraw_task_list_6x9d.png": 37450,
	"./svg/video-meeting.png": 5777,
	"./svg/vision.svg": 84746,
	"./svg/wittyhacks/DesktopSwags/1.png": 37841,
	"./svg/wittyhacks/DesktopSwags/2.png": 7674,
	"./svg/wittyhacks/DesktopSwags/3.png": 25251,
	"./svg/wittyhacks/DesktopSwags/4.png": 95084,
	"./svg/wittyhacks/DesktopSwags/5.png": 64181,
	"./svg/wittyhacks/MobileSwags/6.png": 45058,
	"./svg/wittyhacks/MobileSwags/7.png": 35563,
	"./svg/wittyhacks/MobileSwags/8.png": 14172,
	"./svg/wittyhacks/MobileSwags/9.png": 66437,
	"./svg/wittyhacks/datacode_logo.png": 58057,
	"./svg/wittyhacks/single frame.png": 363,
	"./svg/wittyhacks/wittyhacks-team.png": 3591,
	"./topcoder.jpeg": 68116,
	"./treehouse.jpeg": 15752,
	"./tutorialspoint.jpeg": 78011,
	"./w3schools.jpeg": 92767,
	"./web_tool.jpeg": 9433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;